import { ComponentType, useEffect } from 'react'
import { useLocation } from 'react-router'

import { CustomEvent } from '../enums/customEvent'
import { useCustomEventsRoutes } from '../hooks/useCustomEventsRoutes'
import { dispatchCustomEvent } from '../utils/customEvent'

// In some cases in order for "links" to work properly in views using HashRouter
// we need to send a custom event to the view that is using HashRouter
// and this HOC runs useCustomEventsRoutes which changes the url
// and the view based on that custom event
export const withRouteLinkClickedListener = <TProps extends object>(Component: ComponentType<TProps>) => {
  return (props: TProps) => {
    useCustomEventsRoutes()

    // This HashRouter is its own history object, separate from the shared one the main app's left
    // menu (NavigationMenu.tsx) reads via useLocation(). pushState/replaceState never fire
    // popstate, so the menu never learns about navigations that happen inside this router (e.g.
    // clicking an in-page link, or a sub-navigation tab) - its highlighted item goes stale. Notify
    // on every change so the menu can resync from the address bar.
    const location = useLocation()

    useEffect(() => {
      dispatchCustomEvent(CustomEvent.HashRouterLocationChanged)
    }, [location.pathname, location.hash])

    return <Component {...props} />
  }
}
